import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-feedbacks',
  templateUrl: './feedbacks.component.html',
  styleUrls: ['./feedbacks.component.scss']
})
export class FeedbacksComponent implements OnInit {

  admins = [];
  selectedTitle: string;
  selected: any;
  selectedAdmin: any;
  isLogin = 0;
  feedback = [];
  public stars: any[] = new Array(5);
  currentRate: any = 0;
  show_page = 0;
  current_url: any;
  hidebox: number = 0;
  constructor(private auth: AuthServiceService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.get_url_and_sms_content();
    this.route.params.subscribe((res: any) => {
      this.current_url = res.id;
      this.getFeedback(this.current_url);
    })

  }

  get_url_and_sms_content() {
    this.auth.get_url_and_sms_content().subscribe((response: any) => {
      let saved_urls = [];
      for (let i in response.body) {
        saved_urls.push(response.body[i].url_name);
      }

      this.route.params.subscribe((res: any) => {
        if (!saved_urls.includes(res.id)) {
          this.show_page = 0;
        } else {
          this.show_page = 1;
        }
      })
    });
  }


  addList(event: any) {
    this.feedback = event;

  }
  getFeedback(url) {
    this.auth.get_all_feedback(url).subscribe((response: any) => {
      (response)
        ? this.feedback = response.body
        : this.feedback = [];
    })
  }



}
